module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }